import { render, staticRenderFns } from "./ConfigurarCertificadoForm.vue?vue&type=template&id=37bd6054&scoped=true&"
import script from "./ConfigurarCertificadoForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarCertificadoForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarCertificadoForm.vue?vue&type=style&index=0&id=37bd6054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd6054",
  null
  
)

export default component.exports